import React, { VFC } from 'react';

interface DashboardSettingsBillingSubscriptionCurrentPlanProps {
  subTitle: string;
}

export const DashboardSettingsBillingSubscriptionCurrentPlan: VFC<
  DashboardSettingsBillingSubscriptionCurrentPlanProps
> = ({ subTitle }) => (
  <div className='flex flex-col p-4 bg-bedrock-brand-secondary text-bedrock-white rounded-lg'>
    <span className='text-bedrock-p-strong '>Current Plan</span>
    <span className='text-bedrock-p '>{subTitle}</span>
  </div>
);
